import * as z from "zod/v4";

export const collectAliaSubscriber = {
  name: "collectAliaSubscriber" as const,
  input: z.object({
    email: z.string().email().optional(),
    phone: z.string().optional(),
    popupId: z.union([z.string(), z.number()]).optional(),
    campaignId: z.union([z.string(), z.number()]).optional(),
    campaignTitle: z.string().optional(),
    anonymousId: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    error: z.string().optional(),
  }),
};
